import React from 'react';
import cn from 'classnames';
import StatusDumbView from '../../../DeviationViews/Dumbo/Status';
import s from './Status.scss';
const StatusInlineView = (props)=>{
    const { deviation, width, height } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root']),
        style: {
            width
        }
    }, /*#__PURE__*/ React.createElement(StatusDumbView, {
        width: width,
        height: height,
        deviation: deviation
    }));
};
StatusInlineView.displayName = 'StatusInlineView';
export default StatusInlineView;

//# sourceMappingURL=Status.js.map